import keys from '@/config/keys'
import isEmpty from '@/utils/isEmpty'
import toSnakeCase from '@/utils/toSnakeCase'

// Helper function to flatten nested objects with dot notation
function flattenObject(obj, prefix = '') {
	const flattened = {}

	for (const key in obj) {
		if (obj.hasOwnProperty(key)) {
			const newKey = prefix ? `${prefix}.${key}` : key

			if (typeof obj[key] === 'object' && obj[key] !== null && !Array.isArray(obj[key])) {
				Object.assign(flattened, flattenObject(obj[key], newKey))
			} else {
				flattened[newKey] = obj[key]
			}
		}
	}

	return flattened
}

export default function getTerminology(
	phrase,
	custom_terminology,
	convert = true,
	not_found_return_empty = false,
) {
	if (isEmpty(phrase)) return phrase

	const key = convert ? toSnakeCase(phrase) : phrase

	// Flatten custom_terminology if it exists
	const flatCustomTerminology = custom_terminology ? flattenObject(custom_terminology) : {}

	// Flatten global terminology if it exists
	const globalTerminology = window[keys._TERMINOLOGY_] ?? {}
	const flatGlobalTerminology = flattenObject(globalTerminology)

	// Return the corresponding terminology from custom_terminology if it exists,
	// otherwise return the corresponding terminology from global terminology store -> window._TERMINOLOGY_,
	// and if neither exist, return the original phrase OR undefined.
	return (
		flatCustomTerminology[key] ??
		flatGlobalTerminology[key] ??
		(not_found_return_empty ? undefined : phrase)
	)
}
